export default "__VITE_ASSET__38cdc9c5__"